import React from 'react';
import logo from '../../assets/logo.jpeg';
import './WelcomeNewUser.css';

const WelcomeNewUser = () => {
  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <div className="welcome-logo-wrap">
          <img src={logo} alt="Estudio Metzger" className="welcome-logo" />
        </div>

        <div className="welcome-badge">
          <i className="bi bi-check-circle-fill"></i>
          Cuenta verificada
        </div>

        <h1 className="welcome-title">Bienvenido a Estudio Metzger</h1>
        <p className="welcome-subtitle">
          Nos alegra que te sumes al estudio. Ya formás parte del sistema y en breve
          un administrador te asignara tu primera entidad.
        </p>

        <div className="welcome-steps">
          <div className="welcome-step">
            <div className="welcome-step-icon completed">
              <i className="bi bi-check-lg"></i>
            </div>
            <div className="welcome-step-text">
              <strong>Cuenta creada</strong>
              <span>Tu registro se completo correctamente y ya podes iniciar sesion.</span>
            </div>
          </div>

          <div className="welcome-step">
            <div className="welcome-step-icon pending">
              <i className="bi bi-building"></i>
            </div>
            <div className="welcome-step-text">
              <strong>Asignacion de entidad</strong>
              <span>Un administrador del estudio te va a asignar una o mas entidades. Este proceso se realiza de forma manual.</span>
            </div>
          </div>

          <div className="welcome-step">
            <div className="welcome-step-icon waiting">
              <i className="bi bi-clock-history"></i>
            </div>
            <div className="welcome-step-text">
              <strong>Acceso completo</strong>
              <span>Una vez asignada la entidad, vas a poder acceder a tus carpetas, tramites, calendario y mas funcionalidades.</span>
            </div>
          </div>
        </div>

        <div className="welcome-info-box">
          <i className="bi bi-lightbulb welcome-info-icon"></i>
          <p className="welcome-info-text">
            Mientras tanto, podes aprovechar a configurar tu cuenta desde la seccion
            <strong> Configuracion</strong> del menu lateral: cambia tu contraseña,
            activa la verificacion en dos pasos (2FA) y mantene tus datos al dia.
          </p>
        </div>

        <div className="welcome-divider" />

        <p className="welcome-contact-title">Ante cualquier duda, contactanos</p>
        <div className="welcome-contact-row">
          <div className="welcome-contact-item">
            <i className="bi bi-envelope-fill"></i>
            <span><span className="welcome-contact-label">Email:</span> administracion@estudiometzger.com.ar</span>
          </div>
          <div className="welcome-contact-item">
            <i className="bi bi-whatsapp"></i>
            <span><span className="welcome-contact-label">WhatsApp:</span> 0299 4592972</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeNewUser;
